import styled from 'styled-components'

export const Container = styled.header`
  width: 100vw;
  top: 0;
  margin: 0;
  z-index: 50;
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  //position: relative;
`

export const HeaderWrapper = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    width: 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logoDirecaoDark {
    width: 150px;
    filter: brightness(0) invert(1) saturate(100%) grayscale(100%);
  }

  .logoDirecaoLight {
    width: 150px;
  }

  @media only screen and (min-width: 800px) {
    .logoDirecaoDark {
      width: 190px;
    }

    .logoDirecaoLight {
      width: 190px;
    }
  }
`

export const MenuContainer = styled.div<{ open: boolean }>`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: #00000090;
  z-index: 2000;
  top: 0;

  transition: transform 0.2s ease-in-out;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(-100%)')};
`

export const MenuMobileFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto auto 0;

  p {
    font-size: 0.75rem;
    margin: 0.5rem auto 0;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]}, 0.5)`};
    max-width: 80%;
    text-align: center;
  }

  img {
    height: 1.5rem;
    margin: 0 auto;
  }
`

export const BurgerMenu = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  @media only screen and (min-width: 800px) {
    display: none;
  }
`

export const Hidden = styled.div`
  margin: 0;
  padding: 0;

  @media only screen and (max-width: 800px) {
    display: none;
  }
`

export const MenuWrapper = styled.div<{ open: boolean }>`
  height: 100%;
  width: 100%;
  max-width: 300px;
  background: ${({ theme }) => `rgb(${theme.background.low})`};
  margin: 0 auto 0 0;
  padding: 0.1rem;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  div {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1rem;
  }

  transition: transform 0.5s ease-in-out;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(-100%)')};
`
